module.exports = __webpack_public_path__ + "img/ic_back_white.7820539f.svg";